import { Select, Switch } from 'antd'
import { updateIntegrationWhiteLabel } from 'src/features'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { SettingSection, SettingsSectionParams } from './form.props'
import { WhiteLabelCalculatorType, WhiteLabelCustomerType } from 'src/core/models'

export const behavioralFields = ({
  t,
  formValues,
  setFormValues,
  whiteLabel,
  dispatch,
  integrationId,
  currencyList,
  isMobile
}: SettingsSectionParams): SettingSection[] => [

  { // Calculator mandatory
    isVisible: whiteLabel,
    rowClassName: 'mt-5',
    rowXs1: 19,
    rowXs2: 5,
    labels: {
      title: t('Whitelabel.MandatoryCalculator'),
      subtitle: t('Whitelabel.MandatoryCalculatorLabel')
    },
    form: {
      component: Switch,
      props: {
        checked: formValues?.mandatory_calculator,
        checkedChildren: <CheckOutlined />,
        unCheckedChildren: <CloseOutlined />,
        onChange: (value: boolean) => {
          setFormValues({ ...formValues, mandatory_calculator: value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { mandatory_calculator: value }))
        },
      }
    }
  },

  { // Calculator Type
    isVisible: whiteLabel,
    rowClassName: 'mb-2 mt-2',
    labels: {
      title: t('Whitelabel.CalculatorType'),
      subtitle: t('Whitelabel.CalculatorTypeLabel')
    },
    form: {
      component: Select,
      children: <>
        <Select.Option value={null}>{String(t(`Whitelabel.AnyCalculator`))}</Select.Option>
        <Select.Option value={'Trip'}>{String(t(`Whitelabel.Trip`))}</Select.Option>
        <Select.Option value={'Company'}>{String(t(`Whitelabel.company`))}</Select.Option>
        <Select.Option value={'Lifestyle'}>{String(t(`Whitelabel.Lifestyle`))}</Select.Option>
        <Select.Option value={'AirCargo'}>{String(t(`Whitelabel.AirCargo`))}</Select.Option>
        <Select.Option value={'Flight'}>{String(t(`Whitelabel.Flight`))}</Select.Option>
      </>,
      props: {
        value: formValues?.calculator_type,
        style: { width: isMobile ? '100%' : '90%' },
        size: 'large',
        placeholder: t('Whitelabel.CalculatorTypePlaceholder'),
        onChange: (value: WhiteLabelCalculatorType) => {
          setFormValues({ ...formValues, calculator_type: value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { calculator_type: value }))
        },
      }
    }
  },


  { // Customer Type
    isVisible: whiteLabel,
    rowClassName: 'mb-2 mt-2',
    labels: {
      title: t('Whitelabel.CustomerType'),
      subtitle: t('Whitelabel.CustomerTypePlaceholder')
    },
    form: {
      component: Select,
      children: <>
        <Select.Option value={'choose'}>{String(t(`Whitelabel.Choose`))}</Select.Option>
        <Select.Option value={'company'}>{String(t(`Whitelabel.company`))}</Select.Option>
        <Select.Option value={'individual'}>{String(t(`Validate.Individual`))}</Select.Option>
      </>,
      props: {
        value: formValues?.customer_type,
        style: { width: isMobile ? '100%' : '90%' },
        size: 'large',
        onChange: (value: WhiteLabelCustomerType) => {
          setFormValues({ ...formValues, customer_type: value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { customer_type: value }))
        },
      }
    }
  },

  { // Default Currency
    isVisible: whiteLabel,
    rowClassName: 'mb-2 mt-2',
    labels: {
      title: t('Whitelabel.DefaultCurrency'),
      subtitle: t('Whitelabel.SelectCurrency')
    },
    form: {
      component: Select,
      children: <>{currencyList.map(c => <Select.Option
        value={c.id} key={c.id}>{c.code} <strong>{c.symbol}</strong>
      </Select.Option>)}</>,
      props: {
        value: formValues?.currency_token,
        style: { width: isMobile ? '100%' : '90%' },
        size: 'large',
        onChange: (value: number) => {
          setFormValues({ ...formValues, currency_token: value })
          dispatch(updateIntegrationWhiteLabel(integrationId, { currency_token: value }))
        },
      }
    }
  },
]
